module.exports = __webpack_public_path__ + "static/media/icon-all.3dd56861.svg";